import React from 'react';
import { motion } from 'framer-motion';

export default function LandingPage({onGetStarted,onTeacherLogin}){
  const skills=[
    {emoji:'🏪',title:'Biz World',tag:'ENTREPRENEURSHIP',desc:'Run a virtual business. Handle customers, price products, make profits. Real entrepreneur thinking from Class 3.'},
    {emoji:'💰',title:'Money School',tag:'FINANCIAL LITERACY',desc:'Savings, investing, budgeting — taught through games and stories. Skills most adults wish they learned earlier.'},
    {emoji:'🤖',title:'AI School',tag:'AI AWARENESS',desc:'How does AI work? What is machine learning? Concepts no school teaches — explained simply for kids.'},
    {emoji:'🏆',title:'Olympiad Prep',tag:'COMPETITIVE EDGE',desc:'IMO, NSO, IEO, IGKO practice — 600+ questions matched to class level. Build exam confidence at home.'},
    {emoji:'🔬',title:'STEM Lab',tag:'SCIENCE & TECH',desc:'Experiments, physics puzzles, coding concepts — hands-on STEM that goes beyond the textbook.'},
    {emoji:'📰',title:'News & World',tag:'CURRENT AFFAIRS',desc:'Kid-friendly news, role model stories, and weekly idea challenges. Build awareness and creative thinking.'},
  ];
  const schoolFeatures=[
    {emoji:'📋',title:'Assign & Track Homework',desc:'Create assignments by subject. Students see them on their home screen. Teacher sees who completed it — instantly.'},
    {emoji:'📊',title:'Chapter-wise Performance',desc:'See colour-coded scores per student per chapter. Know exactly who needs help in Fractions before the exam.'},
    {emoji:'🏫',title:'School Leaderboard',desc:'Students compete within your school on XP — healthy motivation without pressure.'},
    {emoji:'⚡',title:'Auto XP & Completion',desc:'Students earn XP for every activity. Assignments mark themselves done when the quiz is finished.'},
  ];
  const stats=[
    {n:'6',label:'Unique Subjects'},
    {n:'Classes\n3–8',label:'Age Group Covered'},
    {n:'Free',label:'To Get Started'},
    {n:'2 min',label:'School Setup Time'},
  ];

  return(
    <div style={{fontFamily:"'Nunito',sans-serif",background:'white',minHeight:'100vh',overflowX:'hidden'}}>

      {/* NAV */}
      <div style={{position:'sticky',top:0,zIndex:100,background:'rgba(255,255,255,0.96)',backdropFilter:'blur(10px)',
        borderBottom:'1px solid #F0F0F0',padding:'0 24px'}}>
        <div style={{maxWidth:1100,margin:'0 auto',display:'flex',alignItems:'center',justifyContent:'space-between',height:64}}>
          <div style={{display:'flex',alignItems:'center'}}>
            <img src="/neevstar_logo.png" alt="NeevStar" style={{height:36,width:'auto'}}/>
          </div>
          <div style={{display:'flex',gap:10,alignItems:'center'}}>
            <button onClick={onTeacherLogin}
              style={{background:'#E8F5F3',border:'none',color:'#00695C',borderRadius:10,
                padding:'9px 18px',cursor:'pointer',fontFamily:"'Nunito',sans-serif",fontWeight:800,fontSize:13}}>
              🏫 For Schools
            </button>
            <button onClick={onGetStarted}
              style={{background:'linear-gradient(135deg,#00695C,#00CFFF)',border:'none',color:'white',borderRadius:10,
                padding:'9px 18px',cursor:'pointer',fontFamily:"'Nunito',sans-serif",fontWeight:800,fontSize:13,
                boxShadow:'0 4px 12px rgba(0,102,255,0.3)'}}>
              Login / Sign Up
            </button>
          </div>
        </div>
      </div>

      {/* HERO */}
      <div style={{background:'linear-gradient(135deg,#0A0A2E 0%,#1A1A5E 60%,#1A3A8F 100%)',
        padding:'80px 24px 72px',textAlign:'center',position:'relative',overflow:'hidden'}}>
        <div style={{position:'absolute',top:0,left:0,right:0,bottom:0,opacity:0.04,
          backgroundImage:'radial-gradient(#fff 1px,transparent 1px)',backgroundSize:'32px 32px'}}/>
        <motion.div initial={{opacity:0,y:30}} animate={{opacity:1,y:0}} transition={{duration:0.6}} style={{position:'relative',maxWidth:700,margin:'0 auto'}}>
          <div style={{display:'inline-block',background:'rgba(255,214,0,0.15)',borderRadius:20,
            padding:'6px 16px',fontSize:12,fontWeight:800,color:'#FFD600',
            letterSpacing:'0.08em',marginBottom:24,border:'1px solid rgba(255,214,0,0.3)'}}>
            🇮🇳 FOR INDIAN SCHOOL STUDENTS — CLASSES 3 TO 8
          </div>
          <h1 style={{fontSize:'clamp(30px,6vw,54px)',fontWeight:900,color:'white',margin:'0 0 20px',lineHeight:1.15}}>
            School teaches the syllabus.<br/>
            <span style={{background:'linear-gradient(90deg,#FFD600,#FF9500)',WebkitBackgroundClip:'text',
              WebkitTextFillColor:'transparent',backgroundClip:'text'}}>NeevStar teaches the future.</span>
          </h1>
          <p style={{fontSize:'clamp(14px,2vw,18px)',color:'rgba(255,255,255,0.8)',
            maxWidth:540,margin:'0 auto 12px',fontWeight:700,lineHeight:1.7}}>
            Entrepreneurship. Money. AI. Olympiad prep. Brain games. Real-world skills that build confident, curious kids — and yes, CBSE practice too.
          </p>
          <p style={{fontSize:13,color:'rgba(255,255,255,0.45)',fontWeight:700,margin:'0 0 36px'}}>
            Free to start • Works on any phone • No downloads needed
          </p>
          <div style={{display:'flex',gap:12,justifyContent:'center',flexWrap:'wrap'}}>
            <motion.button onClick={onGetStarted} whileHover={{scale:1.04}} whileTap={{scale:0.97}}
              style={{background:'linear-gradient(135deg,#FFD600,#FF9500)',border:'none',color:'#1A1A2E',
                borderRadius:14,padding:'16px 32px',fontSize:16,fontWeight:900,cursor:'pointer',
                fontFamily:"'Nunito',sans-serif",boxShadow:'0 8px 24px rgba(255,214,0,0.35)'}}>
              🚀 Start Learning Free
            </motion.button>
            <motion.button onClick={onTeacherLogin} whileHover={{scale:1.04}} whileTap={{scale:0.97}}
              style={{background:'rgba(255,255,255,0.1)',border:'2px solid rgba(255,255,255,0.25)',color:'white',
                borderRadius:14,padding:'16px 32px',fontSize:16,fontWeight:900,cursor:'pointer',
                fontFamily:"'Nunito',sans-serif"}}>
              🏫 Register Your School
            </motion.button>
          </div>
        </motion.div>
        <motion.div initial={{opacity:0,y:20}} animate={{opacity:1,y:0}} transition={{delay:0.45}}
          style={{display:'flex',justifyContent:'center',gap:'clamp(24px,5vw,64px)',marginTop:64,flexWrap:'wrap'}}>
          {stats.map(({n,label})=>(
            <div key={label} style={{textAlign:'center'}}>
              <p style={{margin:0,fontSize:'clamp(22px,4vw,34px)',fontWeight:900,color:'#FFD600',whiteSpace:'pre-line'}}>{n}</p>
              <p style={{margin:'4px 0 0',fontSize:11,color:'rgba(255,255,255,0.55)',fontWeight:700,letterSpacing:'0.06em'}}>{label.toUpperCase()}</p>
            </div>
          ))}
        </motion.div>
      </div>

      {/* SKILL STRIPS */}
      <div style={{background:'white',padding:'16px 24px 0',overflowX:'auto'}}>
        <div style={{display:'flex',gap:10,justifyContent:'center',flexWrap:'wrap',maxWidth:900,margin:'0 auto',paddingBottom:8}}>
          {['🏪 Entrepreneurship','💰 Money School','🤖 AI School','🏆 Olympiad Prep','🔬 STEM Lab','📰 News & World','🧠 Brain Games','🎯 CBSE Practice'].map(tag=>(
            <span key={tag} style={{background:'#E8F5F3',color:'#00695C',borderRadius:20,padding:'6px 14px',
              fontSize:12,fontWeight:800,whiteSpace:'nowrap'}}>
              {tag}
            </span>
          ))}
        </div>
      </div>

      {/* WHAT KIDS ACTUALLY LEARN */}
      <div style={{padding:'72px 24px',background:'#F8F9FF'}}>
        <div style={{maxWidth:1100,margin:'0 auto'}}>
          <div style={{textAlign:'center',marginBottom:48}}>
            <p style={{fontSize:12,fontWeight:900,color:'#00695C',letterSpacing:'0.1em',margin:'0 0 8px'}}>WHAT KIDS ACTUALLY LEARN</p>
            <h2 style={{fontSize:'clamp(22px,4vw,36px)',fontWeight:900,color:'#1A1A2E',margin:'0 0 12px'}}>
              6 skills. One app. Zero boredom.
            </h2>
            <p style={{fontSize:15,color:'#888',fontWeight:700,maxWidth:520,margin:'0 auto'}}>
              Every module is designed to feel like a game — not a test. Kids come back because they want to, not because they have to.
            </p>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(300px,1fr))',gap:20}}>
            {skills.map((s,i)=>(
              <motion.div key={s.title} initial={{opacity:0,y:20}} whileInView={{opacity:1,y:0}}
                viewport={{once:true}} transition={{delay:i*0.06}}
                style={{background:'white',borderRadius:20,padding:24,boxShadow:'0 2px 16px rgba(0,0,0,0.06)',
                  borderTop:'3px solid #00695C'}}>
                <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:12}}>
                  <span style={{fontSize:32}}>{s.emoji}</span>
                  <div>
                    <p style={{margin:0,fontSize:10,fontWeight:900,color:'#00695C',letterSpacing:'0.08em'}}>{s.tag}</p>
                    <h3 style={{margin:0,fontSize:16,fontWeight:900,color:'#1A1A2E'}}>{s.title}</h3>
                  </div>
                </div>
                <p style={{fontSize:13,color:'#666',fontWeight:700,margin:0,lineHeight:1.7}}>{s.desc}</p>
              </motion.div>
            ))}
          </div>
          <motion.div initial={{opacity:0,y:12}} whileInView={{opacity:1,y:0}} viewport={{once:true}}
            style={{marginTop:24,background:'linear-gradient(135deg,#E8F0FF,#F0F8FF)',borderRadius:20,
              padding:'20px 28px',display:'flex',alignItems:'center',gap:16,flexWrap:'wrap'}}>
            <span style={{fontSize:32}}>📖</span>
            <div style={{flex:1}}>
              <p style={{margin:0,fontSize:15,fontWeight:900,color:'#1A1A2E'}}>And yes — CBSE chapter practice is in here too.</p>
              <p style={{margin:'4px 0 0',fontSize:13,color:'#666',fontWeight:700}}>
                504+ questions across Maths, Science & English for Class 3–8. Chapter-wise, with explanations after every answer.
              </p>
            </div>
            <span style={{background:'#00695C',color:'white',borderRadius:10,padding:'6px 14px',fontSize:12,fontWeight:900,whiteSpace:'nowrap'}}>Included Free</span>
          </motion.div>
        </div>
      </div>

      {/* FOR SCHOOLS */}
      <div style={{padding:'72px 24px',background:'linear-gradient(135deg,#0A0A2E,#1A1A5E)'}}>
        <div style={{maxWidth:1100,margin:'0 auto'}}>
          <div style={{textAlign:'center',marginBottom:48}}>
            <p style={{fontSize:12,fontWeight:900,color:'#FFD600',letterSpacing:'0.1em',margin:'0 0 8px'}}>FOR SCHOOLS & TEACHERS</p>
            <h2 style={{fontSize:'clamp(22px,4vw,36px)',fontWeight:900,color:'white',margin:'0 0 16px'}}>
              Give your students an edge.<br/>Without extra work for you.
            </h2>
            <p style={{fontSize:15,color:'rgba(255,255,255,0.65)',fontWeight:700,maxWidth:540,margin:'0 auto'}}>
              NeevStar lets you offer entrepreneurship, AI awareness, and financial literacy to your students — subjects the syllabus doesn't cover — with a teacher dashboard that shows exactly who's engaging.
            </p>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(240px,1fr))',gap:20,marginBottom:48}}>
            {schoolFeatures.map((f,i)=>(
              <motion.div key={f.title} initial={{opacity:0,y:20}} whileInView={{opacity:1,y:0}}
                viewport={{once:true}} transition={{delay:i*0.08}}
                style={{background:'rgba(255,255,255,0.07)',borderRadius:20,padding:24,
                  border:'1px solid rgba(255,255,255,0.1)'}}>
                <p style={{fontSize:32,margin:'0 0 12px'}}>{f.emoji}</p>
                <h3 style={{fontSize:15,fontWeight:900,color:'white',margin:'0 0 8px'}}>{f.title}</h3>
                <p style={{fontSize:13,color:'rgba(255,255,255,0.6)',fontWeight:700,margin:0,lineHeight:1.7}}>{f.desc}</p>
              </motion.div>
            ))}
          </div>
          <div style={{textAlign:'center'}}>
            <motion.button onClick={onTeacherLogin} whileHover={{scale:1.04}} whileTap={{scale:0.97}}
              style={{background:'linear-gradient(135deg,#FFD600,#FF9500)',border:'none',color:'#1A1A2E',
                borderRadius:14,padding:'16px 40px',fontSize:16,fontWeight:900,cursor:'pointer',
                fontFamily:"'Nunito',sans-serif",boxShadow:'0 8px 24px rgba(255,214,0,0.25)'}}>
              🏫 Register Your School — It's Free
            </motion.button>
            <p style={{color:'rgba(255,255,255,0.4)',fontSize:12,fontWeight:700,marginTop:12}}>
              No credit card • 2-minute setup • Share one code with students
            </p>
          </div>
        </div>
      </div>

      {/* HOW IT WORKS */}
      <div style={{padding:'72px 24px',background:'white'}}>
        <div style={{maxWidth:800,margin:'0 auto',textAlign:'center'}}>
          <p style={{fontSize:12,fontWeight:900,color:'#00695C',letterSpacing:'0.1em',margin:'0 0 8px'}}>HOW IT WORKS</p>
          <h2 style={{fontSize:'clamp(22px,4vw,36px)',fontWeight:900,color:'#1A1A2E',margin:'0 0 48px'}}>Set up in 2 minutes. Teach for years.</h2>
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))',gap:32}}>
            {[
              {step:'1',emoji:'🏫',title:'Teacher registers',desc:'Create a free school account. Get a unique code for your school instantly.'},
              {step:'2',emoji:'📱',title:'Students join',desc:"Students sign up and enter your school code. Done — they're connected to your dashboard."},
              {step:'3',emoji:'📋',title:'Assign, track, celebrate',desc:'Assign activities, track who completed them, see scores per chapter. Recognise top performers.'},
            ].map((s,i)=>(
              <motion.div key={s.step} initial={{opacity:0,y:20}} whileInView={{opacity:1,y:0}}
                viewport={{once:true}} transition={{delay:i*0.1}} style={{textAlign:'center'}}>
                <div style={{width:48,height:48,borderRadius:16,background:'linear-gradient(135deg,#00695C,#00CFFF)',
                  display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,fontWeight:900,
                  color:'white',margin:'0 auto 16px',boxShadow:'0 4px 12px rgba(0,102,255,0.25)'}}>
                  {s.step}
                </div>
                <p style={{fontSize:28,margin:'0 0 10px'}}>{s.emoji}</p>
                <h3 style={{fontSize:15,fontWeight:900,color:'#1A1A2E',margin:'0 0 8px'}}>{s.title}</h3>
                <p style={{fontSize:13,color:'#888',fontWeight:700,margin:0,lineHeight:1.7}}>{s.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>

      {/* FINAL CTA */}
      <div style={{padding:'72px 24px',background:'linear-gradient(135deg,#F8F9FF,#E8F0FF)',textAlign:'center'}}>
        <motion.div initial={{opacity:0,y:20}} whileInView={{opacity:1,y:0}} viewport={{once:true}}>
          <p style={{fontSize:40,margin:'0 0 16px'}}>⭐</p>
          <h2 style={{fontSize:'clamp(22px,4vw,34px)',fontWeight:900,color:'#1A1A2E',margin:'0 0 12px'}}>
            Your child's school teaches what was.<br/>
            <span style={{color:'#00695C'}}>NeevStar teaches what's next.</span>
          </h2>
          <p style={{fontSize:15,color:'#888',fontWeight:700,maxWidth:440,margin:'0 auto 32px',lineHeight:1.7}}>
            Free to start. No app store needed. Works on any smartphone.
          </p>
          <div style={{display:'flex',gap:12,justifyContent:'center',flexWrap:'wrap'}}>
            <motion.button onClick={onGetStarted} whileHover={{scale:1.04}} whileTap={{scale:0.97}}
              style={{background:'linear-gradient(135deg,#00695C,#00CFFF)',border:'none',color:'white',
                borderRadius:14,padding:'16px 32px',fontSize:16,fontWeight:900,cursor:'pointer',
                fontFamily:"'Nunito',sans-serif",boxShadow:'0 8px 24px rgba(0,102,255,0.25)'}}>
              🚀 Start Learning Free
            </motion.button>
            <motion.button onClick={onTeacherLogin} whileHover={{scale:1.04}} whileTap={{scale:0.97}}
              style={{background:'white',border:'2px solid #00695C',color:'#00695C',
                borderRadius:14,padding:'16px 32px',fontSize:16,fontWeight:900,cursor:'pointer',
                fontFamily:"'Nunito',sans-serif"}}>
              🏫 Register School
            </motion.button>
          </div>
        </motion.div>
      </div>

      {/* FOOTER */}
      <div style={{background:'#0A0A2E',padding:'32px 24px',textAlign:'center'}}>
        <div style={{display:'flex',alignItems:'center',justifyContent:'center',marginBottom:12}}>
          <img src="/neevstar_logo.png" alt="NeevStar" style={{height:40,width:'auto',filter:'brightness(0) invert(1)',opacity:0.9}}/>
        </div>
        <p style={{color:'rgba(255,255,255,0.35)',fontSize:12,fontWeight:700,margin:'0 0 6px'}}>
          Entrepreneurship • Money • AI • Olympiad • STEM • Classes 3–8
        </p>
        <p style={{color:'rgba(255,255,255,0.2)',fontSize:11,fontWeight:700,margin:0}}>
          © 2025 NeevStar. All rights reserved.
        </p>
      </div>
    </div>
  );
}
